import { useQuery } from '@tanstack/react-query';

import { meApi, meApiKeys } from '@/api/routes/common/me.api';

export const useMe = () => {
  return useQuery({
    queryKey: meApiKeys.read,
    queryFn: () => meApi.read().then((res) => res.data),
  });
};
